/**
 * Different DRM Types
 */
export enum DrmType {
  WIDEVINE = 'widevine',
  PLAYREADY = 'playready',
  FAIRPLAY = 'fairplay',
  UNSUPPORTED = 'UnsupportedBrowser'
}
